import { useEffect, useState } from 'react';
import { Dropdown } from '@zeeve-platform/dropdown-component';
import axios from 'axios';
import Footer from '../../../components/NextAndPrev';
import { getCloudRegionData, getCloudCredList, getInstanceTypes } from '../../../services/cloud';
import { CloudConfigDataZoneTypes, ListFormattedType } from '../declaration';
import { getCloudById } from '../../../utils/helpers';
import Loader from '../../../components/Loader';

interface Props {
    first: boolean;
    prev: () => void;
    nextPage: () => void;
    setCloudConfigDataZone: (obj: CloudConfigDataZoneTypes) => void;
    cloudConfigDataZone: CloudConfigDataZoneTypes;
    submit: () => void;
    last: boolean;
    defaultValue: {
        region: string;
        cloud: string;
        managedHosting: boolean;
        gcpProjectId: string;
    };
    isDisable: boolean;
    cloudId: string;
}
interface RegionBody {
    id: string | number;
    region: string;
    region_name: string;
}
interface Cred {
    id: number | string;
    name: string;
    icon: any;
    projects: { name: string; id: string }[];
}

const CloudConfiguration = ({
    first,
    prev,
    nextPage,
    setCloudConfigDataZone,
    cloudConfigDataZone,
    last,
    submit,
    defaultValue,
    isDisable,
    cloudId,
}: Props) => {
    const [isLoading, toggleLoading] = useState<boolean>(false);
    const [regions, setRegion] = useState([] as RegionBody[]);
    const [cloudName, setCloudName] = useState([] as Cred[]);
    const [instancelist, setInstanceList] = useState([] as { name: string }[]);
    const [showNext, setshowNext] = useState({
        s1: false,
        s2: false,
        s3: false,
        s4: false,
        s5: false,
        s6: false,
        s7: false,
    });
    const cid: string = cloudId;

    const loadRegions = async (id: number | string) => {
        try {
            const response: any = await getCloudRegionData(id);
            // const response:any = await (await axios.get(`http://localhost:3001/cloud/regions/${id}`)).data
            if (response && response.success) {
                setRegion(response.data);
            } else {
                setRegion([]);
            }
        } catch (error) {
            setRegion([]);
        }
    };

    const getCredIds = async (id: string) => {
        try {
            const response: any = await getCloudCredList(id);
            // const response:any = await (await axios.get(`http://localhost:3001/cloud/authorized/${id}`)).data
            if (response && response.success) {
                setCloudName(response.data);
            } else {
                setCloudName([]);
            }
        } catch (error) {
            setCloudName([]);
        }
    };

    const isCloudTypeGcp = () => getCloudById(cloudId) === 'GCP';

    // It will be use in future
    // const regionListModify = (arr: RegionBody[]) => {
    //   const data: ListFormattedType[] = [];
    //   if (arr.length) {
    //     const region_name = regions.find(
    //       (o) => o.id === defaultValue.region,
    //     )?.region_name;
    //     data.push({
    //       label: region_name || '',
    //       value: '',
    //     });
    //     arr.forEach((item: any) => {
    //       data.push({
    //         label: item.region_name,
    //         value: item.id,
    //       });
    //     });
    //   }
    //   return data;
    // };

    // It will be use in future
    // const cloudNameListModify = (arr: Cred[]) => {
    //   const data: ListFormattedType[] = [];
    //   if (arr.length) {
    //     const name:string = cloudName.find((o) => o.id === defaultValue.cloud)?.name || '';
    //     data.push({
    //       label: name || '',
    //       value: '',
    //     });
    //     arr.forEach((item: any) => {
    //       data.push({
    //         label: item.name,
    //         value: item.id,
    //       });
    //     });
    //   }
    //   return data;
    // };

    const instanceTypeListModify = (arr: { name: string }[]) => {
        const data: ListFormattedType[] = [];
        if (arr.length) {
            arr.forEach((item: any) => {
                data.push({
                    label: item.name,
                    value: item.name,
                });
            });
        }
        return data;
    };

    const getInstancetypes = async (id: string) => {
        try {
            const response: any = await getInstanceTypes(id);
            // const response:any = await (await axios.get(`http://localhost:3001/cloud/instance-types/${id}`)).data
            if (response && response.success) {
                setInstanceList(response.data);
            } else {
                setInstanceList([]);
            }
        } catch (error) {
            setInstanceList([]);
        }
    };

    // const getGcpProjectList = (cid: string) => {
    //   getGCPProjectListData(cid)
    //     .then((response) => {
    //       if (response && response.data && response.data.data) { setGcpProjectList(response.data.data); }
    //     })
    //     .catch(() => { setGcpProjectList([]); });
    // };

    useEffect(() => {
        toggleLoading(() => true);
        Promise.all([getCredIds(cid), getInstancetypes(cid), loadRegions(cid)]).finally(() =>
            toggleLoading(() => false),
        );
    }, []);

    const unsetHighlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (b.classList.contains('formEmptyText')) {
                    b.classList.remove('formEmptyText');
                }
            } else {
                b.style.borderColor = '#ECEEF3';
            }
        }
    };
    const highlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (!b.classList.contains('formEmptyText')) {
                    b.classList.add('formEmptyText');
                }
            } else {
                b.style.borderColor = 'red';
            }
        }
    };

    const solve = () => {
        if (defaultValue.managedHosting || cloudConfigDataZone.instanceType) {
            return submit();
        }
        return highlight('instanceType', false);
    };
    const getNameOfGcp = () => {
        const credObj = cloudName.find((o) => o.id === defaultValue.cloud);
        if (credObj) {
            const projectObj = credObj.projects.find((e) => e.id === defaultValue.gcpProjectId);
            return projectObj?.name;
        }
        return '';
    };
    return (
        <>
            <div className=' mt-3 col-11 mx-auto'>
                <div className='row'>
                    <div className='col-xl-8 col-lg-8 col-sm-12 mx-auto'>
                        <div className=' mt-5'>
                            <div className='row mt-3'>
                                <div className='form col-xl-5 col-lg-5 col-md-6 col-sm-12'>
                                    <h6>Region</h6>
                                    <select
                                        className='form-borderradius form-select'
                                        id='z24'
                                        disabled
                                        defaultValue={defaultValue.region}
                                        onChange={(e) => {
                                            unsetHighlight('z24', false);
                                            setshowNext({ ...showNext, s4: true });
                                            setCloudConfigDataZone({ ...cloudConfigDataZone, region: e.target.value });
                                        }}
                                    >
                                        <option className='pt-3'>
                                            {regions.find((o) => o.id === defaultValue.region)?.region_name}
                                        </option>
                                        {regions.map((data, idx) => (
                                            <option
                                                key={`region-${idx.toString()}`}
                                                value={data.id}
                                                selected={defaultValue.region === data.id}
                                            >
                                                {`${data.region} (${data.region_name})`}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {!defaultValue.managedHosting && (
                                    <div className='form  col-xl-5 col-lg-5 col-md-6 col-sm-12 cordaversion2'>
                                        <h6>Cloud Account</h6>
                                        <select
                                            className='form-borderradius form-select'
                                            defaultValue={defaultValue.cloud}
                                            id='z23'
                                            disabled
                                            onChange={(e) => {
                                                unsetHighlight('z23', false);
                                                setshowNext({ ...showNext, s3: true });
                                                setCloudConfigDataZone({
                                                    ...cloudConfigDataZone,
                                                    cloudAccount: e.target.value,
                                                });
                                            }}
                                        >
                                            <option>{cloudName.find((o) => o.id === defaultValue.cloud)?.name}</option>
                                            {cloudName.map((data, idx) => (
                                                <option
                                                    key={`cloud-name${idx.toString()}`}
                                                    value={data.id}
                                                    selected={data.id === defaultValue.cloud}
                                                >
                                                    {data.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                            <div className='row'>
                                {!defaultValue.managedHosting && (
                                    <div className='form  col-xl-5 col-lg-5 col-md-6 col-sm-12 cordaversion2'>
                                        <h6 className='mt-3 mb-3'>Instance Type</h6>
                                        <Dropdown
                                            defaultValue={cloudConfigDataZone.instanceType}
                                            options={instanceTypeListModify(instancelist)}
                                            onChange={(e) => {
                                                setCloudConfigDataZone({
                                                    ...cloudConfigDataZone,
                                                    instanceType: e.target.value,
                                                });
                                                unsetHighlight('instanceType', false);
                                                setshowNext({ ...showNext, s6: true });
                                            }}
                                            selectTitle='Select Instance Type'
                                            id='instanceType'
                                        />
                                    </div>
                                )}
                                {!defaultValue.managedHosting && isCloudTypeGcp() && (
                                    <div className='form  col-xl-5 col-lg-5 col-md-6 col-sm-12 cordaversion2'>
                                        <h6 className='mt-3 mb-3'>GCP Project</h6>
                                        <select
                                            className='form-borderradius form-select'
                                            defaultValue={defaultValue.gcpProjectId}
                                            id='gcpList'
                                            disabled
                                            onChange={(e) => {
                                                setCloudConfigDataZone({
                                                    ...cloudConfigDataZone,
                                                    gcpProjectId: e.target.value,
                                                });
                                                setshowNext({ ...showNext, s3: true });
                                                unsetHighlight('gcpList', false);
                                            }}
                                        >
                                            <option>{getNameOfGcp()}</option>
                                        </select>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='mt-5' style={{ textAlign: 'center' }}>
                        <div className='row text-center'>
                            <p id='errorTag' style={{ display: 'none', fontSize: 14, color: 'red' }}>
                                Error
                            </p>
                            <p id='errorTag2' style={{ display: 'none', fontSize: 14, color: 'red' }}>
                                Error
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <Loader />}
            <Footer
                isLastPage={last}
                submit={solve}
                isFirstPage={first}
                nextPage={nextPage}
                prevPage={prev}
                submitText='Create'
            />
        </>
    );
};
export default CloudConfiguration;
